import { useAuthSessionQuery } from '../api/authApi';

/**
 * Чи триває сесія спостерігача (GET /auth/me → observer: true): застосунок лише для перегляду від імені обраної особи. Сервер однаково
 * відхиляє будь-який запис (не-GET → 403); інтерфейс за цією ознакою ховає дії, що змінюють дані.
 */
export function useIsObserver(): boolean {
  const { data } = useAuthSessionQuery();
  return data?.observer === true;
}
